module.exports = __webpack_public_path__ + "img/4.41cba1a0.png";